// removed by extract-text-webpack-plugin
module.exports = {"saveSearchBlock":"G3BoaHW05R4rguvqgn-Oo","saveSearchDescription":"_1UWikB9J34d_4vL4Qlvu0K"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertiesListSaveSearchBlock/PropertiesListSaveSearchBlock.scss
// module id = 1718
// module chunks = 0